export default __webpack_public_path__ + "static/media/2.675b5ee9.png";